import { render, staticRenderFns } from "./AddToppingMenu.vue?vue&type=template&id=9f4a914a&scoped=true&"
import script from "./AddToppingMenu.vue?vue&type=script&lang=js&"
export * from "./AddToppingMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddToppingMenu.vue?vue&type=style&index=0&id=9f4a914a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4a914a",
  null
  
)

export default component.exports